import { Table } from 'antd';
import { billListSelectors } from 'containers/App/selectors';
import { getDataOther } from 'pages/ListBilling/thunk';
import { useMemo } from 'react';
import { useEffect } from 'react';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { t_billing_process } from 'types';

type Props = {
  bill: t_billing_process;
  loadData: boolean;
  setLoadData: any;
};

const TableOther: FC<Props> = ({ bill, loadData, setLoadData }) => {
  const dispatch = useDispatch();
  const { detailOther } = useSelector(billListSelectors);

  useEffect(() => {
    (async () => {
      if (loadData) {
        const result: any = await dispatch(getDataOther({ invoice_id: bill.invoice_id }));
        if (result.payload) {
          setLoadData(false);
        }
      }
    })();
  }, [bill.invoice_id, dispatch, loadData, setLoadData]);
  const columns: any = useMemo(() => {
    return [
      {
        title: '概要',
        dataIndex: 'detail_name',
        key: 'detail_name',
        width: '35%',
        align: 'center',
        render(text: string, row: any, index: number) {
          return {
            props: {
              style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
              className: 'standardFont',
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: '数量',
        dataIndex: 'other_detail_count',
        key: 'other_detail_count',
        width: '10%',
        align: 'center',
        render(text: string) {
          return {
            props: {
              style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
              className: 'standardFont',
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: '単価',
        key: 'other_detail_unit_price',
        dataIndex: 'other_detail_unit_price',
        width: '15%',
        align: 'center',
        render(text: string) {
          return {
            props: {
              style: { textAlign: 'left' },
              className: 'standardFont',
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: '備考',
        key: 'other_detail_remark',
        dataIndex: 'other_detail_remark',
        width: '40%',
        align: 'center',
        render(text: string) {
          return {
            props: {
              style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left', paddingLeft: '10px' },
              className: 'standardFont',
            },
            children: <div>{text}</div>,
          };
        },
      },
    ];
  }, []);

  return (
    <div>
      <Table columns={columns} dataSource={detailOther ?? []} pagination={false} />
    </div>
  );
};

export default TableOther;
